import { userHasRight } from "../../../framework";
import { toolTip } from "../../controls/toolTip";
import { ll } from "../../core/ll";
import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_PaneIconLink from "../templates/K_PaneIconLink";
import { ComponentOptions, RightLockable } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface PaneIconLinkOptions extends ComponentOptions {
    toolTip?: string;
    bindLabel?: string;
    iconClass?: string;
    counterClass?: string;
    counterValue?: string;
    href?: string;
    requiredRight?: string;
}

export class PaneIconLink extends TemplateComponent {

    options: PaneIconLinkOptions & RightLockable;
    rightLocked?: boolean;

    constructor(options: PaneIconLinkOptions) {
        super(K_PaneIconLink, options);
    }

    preRender() {
        const me = this,
            options = this.options;

        options.bindLabel = buildDataBindSyntax(options.bindLabel, "label");
        options.toolTip = ll(options.toolTip);

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.disabled = true;
                options.containerClasses += " right-locked";
            }
        }
    }

    create() {
        if (this.options.toolTip) {
            toolTip({
                selector: $(`#${this.id}`)
            });
        }
    }

}
